<template>
  <div class="flex flex-row gap-4">
    <div>
      <SimpleText :content="t('sendGcode')" />
      <PurpleFileInputField v-model="file" @change="uploadFile" type=".gcode"  />
    </div>

    <div>
      <SimpleText :content="t('sendAndPrintGcode')" />
      <PurpleFileInputField v-model="file" @change="uploadAndPrintFile" type=".gcode"  />
    </div>
  </div>
</template>

<script setup>

import PurpleFileInputField from "@/components/molecules/PurpleFileInputField.vue";
import {defineProps, ref} from "vue";
import xhr from "@/utils/xhr";
import {jsonValidator} from "@/utils/JsonValidator";
import {t} from "@/utils/Traduction";
import {NotificationStores} from "@/stores/NotificationStores";
import SimpleText from "@/components/atoms/SimpleText.vue";

const props = defineProps({
  uuid: {
    type: String,
    required: true,
  },
});

const notificationStore = NotificationStores();

const file = ref(null);

const uploadFile = () => {
  return new Promise((res, rej) => {
    xhr.addRequestToQueue("POST", "/imprimantes/upload/" + props.uuid, file.value, true, true, false,
        (response) => {
          if(response.code !== 200) {
            if (response.code === 0 || !jsonValidator.validate(response.response)) {
              notificationStore.addNotification(
                  t("errorDuringSendFile"),
                  "error");
              rej()
            } else {
              notificationStore.addNotification(
                  JSON.parse(response.response).message,
                  "error");
              rej()
            }
          } else {
            res()
          }
        });
  });
}

const uploadAndPrintFile = () => {
    uploadFile().then(() => {
      xhr.addRequestToQueue("POST", "/imprimantes/print/" + props.uuid, {fileName: file.value.name}, true, true, false,
          (response) => {
            if(response.code !== 200) {
              if (response.code === 0 || !jsonValidator.validate(response.response)) {
                notificationStore.addNotification(
                    t("errorDuringSendFile"),
                    "error");
              } else {
                notificationStore.addNotification(
                    JSON.parse(response.response).message,
                    "error");
              }
            }
          });
    });
}

</script>

<style scoped>

</style>